import axios from 'axios';
// import util from '@/utils/api'

const api_base_url = process.env.VUE_APP_SHOP_ENDPOINT_BASE_URL

var openapi_server = axios.create({
    baseURL: api_base_url,
    headers: {
        'Content-Type': 'application/json'
    }
});

const getConfig = headerparams => { return { headers: { ...headerparams } }; };

export const getToken = params => { return openapi_server.get(`/startweb.php?to=${params.t}&cs=${params.c}`) }

export const getProducts = headerparams => {
    let cartid = localStorage.getItem('cartid');
    return openapi_server.get(`/productlist.php?nocache=${new Date().getTime()}&cartid=${cartid}`, getConfig(headerparams))
}


export const getShopingcart = headerparams => {
    let cartid = localStorage.getItem('cartid');
    return openapi_server.get(`/shoppingcart.php?f=get&nocache=${new Date().getTime()}&cartid=${cartid}`, getConfig(headerparams))
}

export const updatePayment = (params, headerparams) => {
    let cartid = localStorage.getItem('cartid');
    return openapi_server.get(`shoppingcart.php?f=setpayment&pmtid=${params.to_payment_type}&nocache=${new Date().getTime()}&cartid=${cartid}`, getConfig(headerparams))
}

export const setPickupDelivery = (params, headerparams) => {
    return openapi_server.get(`shoppingcart.php?f=setpickupdelivery&is_pickup=${params.is_pickup}&nocache=${new Date().getTime()}`, getConfig(headerparams))
}


export const sendPromoPhoneNumber = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('text', params.text);
    myformData.set('f', 'store_promo_phone_number');
    return openapi_server.post(
        `shoppingcart.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getAccount = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('cartid', localStorage.getItem('cartid'));
    myformData.set('register_it', params.register_it);

    if(params.register_it === 1) {
        myformData.set('firstname', params.firstname);
        myformData.set('lastname', params.lastname);
        myformData.set('couponcode', params.couponcode);
        myformData.set('notifysms', params.notifysms);
        myformData.set('notifyemail', params.notifyemail);
    }

    return openapi_server.post(
        `account.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const uploadDocument = (params, headerparams) => {

    var myformData = new FormData();
    myformData.set('image', params.image);
    myformData.set('long', params.long);
    myformData.set('lat', params.lat);
    myformData.set('firstname',btoa(params.firstname));
    myformData.set('lastname', btoa(params.lastname));
    myformData.set('phototype', params.phototype);

    return openapi_server.post(
        `rcvpht.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const setSigninLog = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'log_signin');
    myformData.set('signinusername', params.signinusername);
    myformData.set('type', params.type);
    myformData.set('cartid', localStorage.getItem('cartid'));
    return openapi_server.post(
        `signinlog.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const checkCartId = (params, headerparams) => {

    var myformData = new FormData();
    myformData.set('cartid', params.cartid);
    myformData.set('browserstring', params.browserstring);
    return openapi_server.post(
        `start.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const updateAccountData = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'update_account_data');
    myformData.set('email', params.email);
    myformData.set('phone', params.phone);
    return openapi_server.post(
        `webapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getDLMCData = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'get_DL_MC_data');
    return openapi_server.post(
        `webapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getPendingDeliveryStatus = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'get_pending_delivery');
    return openapi_server.post(
        `webapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const loadRewardsData = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'get_rewards_data');
    return openapi_server.post(
        `webapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const updateDeliveryGPS = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'getdrivergps');
    return openapi_server.post(
        `delloc.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const shopingcartOrder = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'placeorder');
    myformData.set('cartid', localStorage.getItem('cartid') );
    myformData.set('instructions', params.special_instructions_message);
    myformData.set('location_id', params.location_id);
     return openapi_server.post(
         `shoppingcart.php`,
         myformData,
         getConfig({'Content-Type': 'multipart/form-data',...headerparams})
     )
}

export const setOverallPromoCode = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'set_overall_promo_code');
    myformData.set('cartid', localStorage.getItem('cartid') );
    myformData.set('overall_promo_code', params.promocoupon);
    return openapi_server.post(
        `shoppingcart.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const updateShopingcart = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'update');
    myformData.set('cartid', localStorage.getItem('cartid') );
    myformData.set('sku', params.sku);
    myformData.set('qty', params.qty);
    return openapi_server.post(
        `shoppingcart.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const addPromoItem = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'add_promo_item');
    myformData.set('cartid', localStorage.getItem('cartid') );
    myformData.set('sku', params.sku);
    myformData.set('promo_id', params.promo_id);
    return openapi_server.post(
        `shoppingcart.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const setCartProductQuantity = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'set_product_quantity');
    myformData.set('cartid', localStorage.getItem('cartid') );
    myformData.set('productid', params.productid);
    myformData.set('quantity', params.quantity);

    return openapi_server.post(
        `shoppingcart.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const placeRewardOrder = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('f', 'place_reward_order');
    myformData.set('quantity', params.quantity);
    myformData.set('sku', params.sku);
    myformData.set('firstname', params.firstname);
    myformData.set('lastname', params.lastname);
    myformData.set('address', params.address);
    myformData.set('city', params.city);
    myformData.set('zipcode', params.zipcode);
    myformData.set('state', params.state);
    myformData.set('phone', params.phone);
    return openapi_server.post(
        `shoppingcart.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const orderHistory = (params, headerparams) => {
    return openapi_server.get(`/orderhistory.php?f=get&limit=${params.limit}&orderid=${params.order_id}&nocache=${new Date().getTime()}`,getConfig(headerparams))
}

export const rewardHistory = (params, headerparams) => {
    return openapi_server.get(`/rewardhistory.php?f=get&limit=${params.limit}&nocache=${new Date().getTime()}`,getConfig(headerparams))
}


export const loadPagesProducts = (params, headerparams) => {
    var myformData = new FormData();
    myformData.set('cartid', localStorage.getItem('cartid'));
    return openapi_server.post(
        `productlist.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',
            'authorization': params.authorization,
            ...headerparams})
    )

    // todo: why do we have to set the authorization here and why is it not in headerparams?
}


